<h3 class="vc-title-s register__title" i18n="@@AUTH.REGISTER_OFFER">Register to get {{ promoOffer }} off</h3>
<p class="register__intro vc-d-none vc-d-md-block vc-text-m" i18n="@@AUTH.REGISTER_INTRO">
  Buy, sell and unlock more: Save favourite items, track price drops & make offers!
</p>
<div class="register__newsletterContainer">
  <vc-facebook-connect
    class="register__facebookregister"
    [type]="'register'"
    (registerNextStep)="setUserFromFacebook($event)"
  ></vc-facebook-connect>

  <div class="register__or" i18n="@@LOGIN_MODAL.OR">or</div>

  <form novalidate [formGroup]="emailForm" id="formNewsletter" class="register__formNewsletter" (ngSubmit)="onSubmit()">
    <p *ngIf="error" aria-live="assertive" class="vc-form__error">{{ error }}</p>
    <div class="form-group vc-form-text register__field register__vcregister">
      <input type="email" id="user_email" class="vc-form-text__input" formControlName="email" required />

      <label class="vc-form-text__label vc-text-m" for="user_email">
        <div *ngIf="email.errors && email.dirty" aria-live="assertive">
          <span *ngIf="email?.errors.required" i18n="@@LOGIN_MODAL.ERROR_REQUIRED_EMAIL">Email is required</span>
          <span *ngIf="email?.errors.pattern" i18n="@@LOGIN_MODAL.ERROR_PATTERN_EMAIL">Incorrect email address</span>
        </div>

        <span *ngIf="email.valid || !email.dirty" i18n="@@REGISTER_MODAL.EMAIL">Email *</span>
      </label>
    </div>

    <p class="register__requiredFieldMention" i18n="@@REGISTER_MODAL.MANDATORY_FIELD">* Required field</p>

    <button
      class="vc-btn vc-btn--large vc-btn--full vc-btn--primary"
      type="submit"
      [disabled]="!emailForm.valid"
      i18n="@@REGISTER_MODAL.JOIN_COMMUNITY_BUTTON"
    >
      Join the community
    </button>
  </form>
</div>
